import React from "react";

export default (props) => {
  const { style, value } = props;

  return <div><a style={style} href={value}>Visit link</a></div>;
}
